function parseResponseData(data) {
  if((!data) || data.length==0){
      return null;
  }
  else {
    return JSON.stringify(data);
  }
}

function serviceFactory({ api }) {
  const getAssetList = ({portfolioId, asset, metaData}) =>
    api
    .getAssetList(portfolioId, asset, metaData)
    .then(parseResponseData);

    return {
      getAssetList
    }
}

module.exports = serviceFactory;